const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Breaking%20news%20investigation%20concept%2C%20dramatic%20editorial%20scene%20with%20warm%20red%20and%20cream%20tones%2C%20documentary%20style%2C%20floating%20newspaper%20fragments%2C%20soft%20dramatic%20lighting%2C%20investigative%20journalism%20atmosphere&width=1200&height=700&seq=carousel-01&orientation=landscape',
    tag: '深度调查',
    title: '独家揭秘：某行业巨头内部管理混乱的内幕调查',
    desc: '记者历时三个月深入调查，揭开了这家表面光鲜的企业背后不为人知的真相。从供应链管理到员工待遇，从财务操作到合规风险，每一个环节都暴露出严重问题。本专题将全面还原事件全貌。',
    time: '2026.07.28',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Data%20breach%20cybersecurity%20news%20concept%2C%20abstract%20digital%20security%20theme%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20editorial%20documentary%20style%2C%20dramatic%20soft%20lighting&width=1200&height=700&seq=carousel-02&orientation=landscape',
    tag: '数据安全',
    title: '多家知名App被曝违规收集用户隐私数据',
    desc: '安全研究团队最新报告显示，多款日活过亿的知名移动应用存在超范围收集用户隐私数据的行为，涉及位置信息、通讯录、相册等敏感权限。目前相关监管部门已启动调查程序。',
    time: '2026.07.27',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Financial%20scandal%20investigation%20abstract%20concept%2C%20dramatic%20editorial%20photography%20style%2C%20warm%20red%20accents%20on%20cream%20background%2C%20soft%20shadows%2C%20documentary%20atmosphere%2C%20clean%20minimalist%20composition&width=1200&height=700&seq=carousel-03&orientation=landscape',
    tag: '财经调查',
    title: '某上市公司百亿市值蒸发背后：财务造假疑云',
    desc: '连续三个季度财报数据出现重大异常，审计机构突然宣布辞任，多家投行紧急下调评级。本报独家获取的内部文件显示，该公司可能存在系统性的财务造假行为，涉及金额或超百亿。',
    time: '2026.07.26',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Environmental%20protection%20investigation%20news%20concept%2C%20industrial%20pollution%20abstract%20theme%2C%20warm%20golden%20and%20cream%20tones%2C%20editorial%20documentary%20style%20photography%2C%20dramatic%20soft%20lighting%2C%20clean%20composition&width=1200&height=700&seq=carousel-04&orientation=landscape',
    tag: '环保曝光',
    title: '暗访实录：某地化工厂长期违规排污触目惊心',
    desc: '本报记者经过长达半年的暗访调查，发现某地大型化工厂存在长期偷排工业废水、废气的问题，周边居民健康受到严重威胁。当地环保部门已介入调查，涉事企业被责令停产整顿。',
    time: '2026.07.25',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-label font-semibold text-accent-600 uppercase tracking-wider">
            焦点专题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mt-2 mb-3">
            深度爆料专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            精选深度调查报道专题，全方位还原事件真相
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-background-300 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full text-xs font-semibold bg-primary-500 text-background-50">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-foreground-400 font-label">{item.time}</span>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 leading-snug mb-3 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}